<template>
  <div
    class="wrapper pa-4"
  >
    <h1>立方体放在文字段落的中间</h1>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur, assumenda minus, tempora sit minima voluptates labore illo voluptas numquam libero praesentium soluta odit quo, qui fugit tenetur quos! Perferendis, eligendi?
      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Consequatur, assumenda minus, tempora sit minima voluptates labore illo voluptas numquam libero praesentium soluta odit quo, qui fugit tenetur quos! Perferendis, eligendi?
      <canvas
        id="c"
      />
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Natus minus amet, porro molestiae quaerat rerum, sunt maxime excepturi corrupti delectus facilis voluptatibus itaque ipsa placeat dolore quas? Rerum, sit quasi.
      Lorem, ipsum dolor sit amet consectetur adipisicing elit. Natus minus amet, porro molestiae quaerat rerum, sunt maxime excepturi corrupti delectus facilis voluptatibus itaque ipsa placeat dolore quas? Rerum, sit quasi.
    </p>

    <highlightjs
      class="mt-4"
      :code="`#c {
  float: left;
  margin: 5px;
  width: 300px;
  height: 150px;
}`"
      :language="'css'"
    />
  </div>
</template>

<script type="module">
import * as THREE from 'three';

export default {
  data() {
    return {
      fov: 75, // 相机视野范围
      aspect: 2, // 画布的宽高比 在默认情况下 canvas画布是300x150像素，所以宽高比为300/150或者说2
      near: 0.1, // 相机近平面
      far: 5, // 相机远平面

      boxWidth: 1,
      boxHeight: 1,
      boxDepth: 1,
    };
  },
  mounted() {
    this.main();
  },
  methods: {
    main() {
      const canvas = document.querySelector('#c');
      const renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      const {fov, aspect, near, far} = this;
      const camera = new THREE.PerspectiveCamera(fov, aspect, near, far);
      console.log(renderer, 'renderer 1', camera, 'camera 1');

      // 摄像机默认指向Z轴负方向，上方向朝向Y轴正方向。我们将会把立方体放置在坐标原点，所以我们需要往后移一下摄像机才能显示出物体
      camera.position.x = 0;
      camera.position.z = 3;
      camera.position.y = 0.8;

      // 然后我们创建一个场景(Scene)。
      const scene = new THREE.Scene();

      // 然后创建一个包含盒子信息的立方几何体(BoxGeometry)。几乎所有希望在three.js中显示的物体都需要一个包含了组成三维物体的顶点信息的几何体。
      const {boxWidth, boxHeight, boxDepth} = this;
      const geometry = new THREE.BoxGeometry(boxWidth, boxHeight, boxDepth);
      // 然后创建一个基本的材质并设置它的颜色. 颜色的值可以用css方式和十六进制来表示。
      // const material = new THREE.MeshBasicMaterial({color: 0x44aa88});
      const material = new THREE.MeshPhongMaterial({
        color: 0x44aa88, // 绿蓝色 受灯光影响的MeshPhongMaterial材质
      });
      // 再创建一个网格(Mesh)对象，它包含了 geometry(几何体 物体的形状) material(材质 如何绘制物体，光滑还是平整，什么颜色，什么贴图..)
      const cube = new THREE.Mesh(geometry, material);
      // 修改位置
      cube.position.x = -0.5;
      cube.position.y = 1.8;
      cube.position.z = -1.8;
      

      // 最后我们将网格添加到场景中。
      scene.add(cube);
      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      renderer.render(scene, camera);

      // 立方体旋转
      function render(time) {
        time *= 0.001;  // 将时间单位变为秒
      
        cube.rotation.x = time;
        cube.rotation.y = time;

        cubes.forEach((cube, ndx) => {
          const speed = 1 + ndx * .1;
          const rot = time * speed;
          cube.rotation.x = rot;
          cube.rotation.y = rot;
        });
      
        renderer.render(scene, camera);
      
        requestAnimationFrame(render);
      }
      requestAnimationFrame(render);

      // 灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      scene.add(light);

      function makeInstance(geometry, color, x) {
        const material = new THREE.MeshPhongMaterial({color});
      
        const cube = new THREE.Mesh(geometry, material);
        scene.add(cube);
      
        cube.position.x = x;
      
        return cube;
      }

      const cubes = [
        makeInstance(geometry, 0x44aa88,  0),
        makeInstance(geometry, 0x8844aa, -2),
        makeInstance(geometry, 0xaa8844,  2),
      ];
      scene.add(cubes);

    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

#c {
  float: left;
  margin: 5px;
  width: 300px;
  height: 150px;
}

</style>